import React from "react";
import { MDXProvider as BaseMDXProvider } from "@mdx-js/react";
import Link from "decodable-ui/lib/components/Link";
import Prism from "decodable-ui/lib/components/Prism";
import { useActiveAccount } from "../../accounts/hooks/useAccounts";
import { Launch } from "@mui/icons-material";
import CopyButton from "decodable-ui/lib/components/CopyButton";
import { Box } from "@mui/system";
import { useSnackbar } from "../../components/SnackbarProvider";

export function MDXProvider({ children }: { children: React.ReactNode }) {
  return (
    <BaseMDXProvider
      components={{
        a: Anchor,
        pre: Pre,
      }}
    >
      {children}
    </BaseMDXProvider>
  );
}

export function Anchor(props: any) {
  const { activeAccount } = useActiveAccount();

  return props.href[0] == "~" ? (
    <Link
      {...props}
      href={props.href.replace(/^~/, "/" + activeAccount?.name)}
    />
  ) : (
    <a target="_blank" {...props}>
      {props.children}
      <Launch sx={{ fontSize: "0.8em", verticalAlign: "middle" }} />
    </a>
  );
}

export function Pre(props: any) {
  const showSnackbar = useSnackbar();

  const copyButtonWidth = "3.2ch";

  const isSQL = props.children.props.className == "language-sql";
  const style = {
    overflowX: "auto" as const,
    border: "1px solid rgb(90% 90% 90%)",
    borderRadius: "1ch",
    padding: `1ch ${copyButtonWidth} 1ch 1ch`,
  };

  if (isSQL) {
    return (
      <Box sx={{ position: "relative" }}>
        <Prism language="sql" style={style}>
          {props.children}
        </Prism>
        <CopyButton
          text={props.children.props.children}
          sx={{
            width: copyButtonWidth,
            padding: "4px",
            fontSize: "inherit",
            position: "absolute",
            top: "0px",
            right: "0px",
            bgcolor: "white",
            "&:hover": {
              bgcolor: "rgb(95% 95% 95%)",
            },
            borderRadius: "1ch",
            border: "1px solid rgb(90% 90% 90%)",
          }}
          onClick={() => showSnackbar({ title: "Copied!" })}
        />
      </Box>
    );
  }

  return <pre style={style}>{props.children}</pre>;
}
